/** @module ProductSpec/SizeChartForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def/Field",
	"csi/form/Widget"
], function(declare,lang,config,Field,Widget) {

	return declare(Widget, {

		SUBTYPE: "Subtype",

		_hasActiveSizeChartSubtype: function() {
			// summary: return true if there is any Active SizeChartSubtype SizeChartSubtypeSettings
			const classType = this.defView.getRootClass().getType();
			return config.hasSubtype(classType);
		},

		_insertSubtypeField: function() {
			this.insertFieldIfNotExist(this.SUBTYPE, 1);
		},

		_resolveView: function() {
			// insert field for "Subtype" if there is any Active SizeChartSubtype,
			// parent is Shape, and field is not already defined in BOs
			if (this._hasActiveSizeChartSubtype() && !this.getField(this.SUBTYPE) &&
				this.defView.getSource().getParent().$Type == "Shape") {
				this._insertSubtypeField();
			}
			this.inherited(arguments);
		}
	});
});